'use es6';

import getIn from 'transmute/getIn';
export const getIsFullscreen = getIn(['isFullscreen']);